'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Stats = exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _File = require('./File.scss');

var _File2 = _interopRequireDefault(_File);

var _components = require('components');

var _messages = require('redux/modules/messages');

var _reactRedux = require('react-redux');

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _account = require('redux/modules/account');

var _channel = require('redux/modules/channel');

var _auth = require('redux/modules/auth');

var _reduxConnect = require('redux-connect');

var _useBasename = require('../../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var File = (_dec = (0, _reduxConnect.asyncConnect)([{
    key: "auth",
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        if (!(0, _auth.isLoaded)(getState())) {
            return dispatch((0, _auth.load)());
        }
        return null;
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return { account: state.account.data, auth: state.auth };
}, {
    messageSendFile: _messages.messageSendFile,
    messageUpdateFileStats: _messages.messageUpdateFileStats,
    getAccount: _account.getAccount,
    getEmailChannel: _channel.getEmailChannel,
    load: _auth.load
}), _dec(_class = _dec2(_class = function (_React$Component) {
    (0, _inherits3.default)(File, _React$Component);

    function File(props) {
        (0, _classCallCheck3.default)(this, File);

        var _this = (0, _possibleConstructorReturn3.default)(this, (File.__proto__ || (0, _getPrototypeOf2.default)(File)).call(this, props));

        _this.changeFlagStatus = function () {
            _this.setState({ flag: false });
        };

        _this.state = {
            stats: null,
            variables: null,
            filename: null,
            flag: false,
            file_data: null,
            created_byUser: _this.props.auth.data.user.email
        };
        return _this;
    }

    (0, _createClass3.default)(File, [{
        key: 'onFileAdded',
        value: function onFileAdded(filename, formData) {
            this.getFileStats(formData, filename);
        }
    }, {
        key: 'getFileStats',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(formData, filename) {
                var fileWithMeta, file_data, flag, fileInfo, stats;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                fileWithMeta = formData, file_data = void 0, flag = false;

                                fileWithMeta.append('created_by', this.state.created_byUser);
                                _context.next = 4;
                                return this.props.messageSendFile(fileWithMeta, 'email');

                            case 4:
                                fileInfo = _context.sent;

                                file_data = { _id: fileInfo._id, file_format: 'EMAIL', channel_type: 'EMAIL' };
                                _context.next = 8;
                                return this.props.messageUpdateFileStats(file_data, 'email');

                            case 8:
                                stats = _context.sent;

                                if (stats) {
                                    flag = true;
                                }
                                this.setState({ stats: stats, filename: filename, flag: flag, file_data: file_data });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getFileStats(_x, _x2) {
                return _ref2.apply(this, arguments);
            }

            return getFileStats;
        }()
    }, {
        key: 'readFileData',
        value: function readFileData(dataFile) {
            var fileHeader = dataFile[0];
            var variables = [];
            for (var key in fileHeader) {
                if (key !== 'email') {
                    key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
                    variables.push(key);
                }
            }
            this.setState({ variables: variables });
        }
    }, {
        key: 'render',
        value: function render() {
            return this.state.flag ? _react2.default.createElement(Stats, { data: this.state, changeFlagStatus: this.changeFlagStatus,
                completeComponentFunction: this.props.completeComponentFunction,
                dataBetweenComponents: this.props.dataBetweenComponents }) : _react2.default.createElement(
                'div',
                { className: _File2.default.selectorDropZone },
                _react2.default.createElement(
                    'div',
                    { className: _File2.default.hintsContainer },
                    _react2.default.createElement(
                        'div',
                        { className: _File2.default.headerMen },
                        'Instrucciones'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _File2.default.instructionContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.hintContainer },
                            _react2.default.createElement('img', { className: _File2.default.exampleIcon, src: (0, _useBasename2.default)('/static/csvExample.svg'), alt: '' }),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.headerContainer },
                                (0, _translations2.default)('CSV HINT')
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.hintContainer },
                            _react2.default.createElement('img', { className: _File2.default.exampleIcon, src: (0, _useBasename2.default)('/static/contactExample.svg') }),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.headerContainer },
                                (0, _translations2.default)('EMAIL HINT')
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.hintContainer },
                            _react2.default.createElement('img', { className: _File2.default.exampleIcon, src: (0, _useBasename2.default)('/static/messageExample.svg') }),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.headerContainer },
                                (0, _translations2.default)('EMAIL VARIABLES')
                            )
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://s3.amazonaws.com/public-im-resources/email-sample-1.csv', download: true },
                            _react2.default.createElement('img', { style: { height: '90px' }, src: (0, _useBasename2.default)('/static/downloadFile.svg') }),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.downloadHeader },
                                (0, _translations2.default)('FILE TEMPLATE DOWNLOAD')
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _File2.default.dropZoneHolder },
                    _react2.default.createElement(_components.DropZone, {
                        style: { height: '100%', width: '510px' },
                        onFileAdded: this.onFileAdded.bind(this),
                        readFileData: this.readFileData.bind(this) })
                )
            );
        }
    }]);
    return File;
}(_react2.default.Component)) || _class) || _class);
exports.default = File;

var Stats = exports.Stats = function (_React$Component2) {
    (0, _inherits3.default)(Stats, _React$Component2);

    function Stats(props) {
        (0, _classCallCheck3.default)(this, Stats);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (Stats.__proto__ || (0, _getPrototypeOf2.default)(Stats)).call(this, props));

        _this2.addVariable = function (key) {
            var subjectInput = _this2.subjectInputRef.current;
            var index = subjectInput.selectionStart;
            var oldSubject = _this2.state.subject;
            var newSubject = oldSubject.slice(0, index) + '[' + key + ']' + oldSubject.slice(index);
            _this2.setState({ subject: newSubject }, function () {
                _this2.props.completeComponentFunction(true);
                _this2.props.dataBetweenComponents(_this2.state);
            });
        };

        _this2.getSubject = function (text) {
            _this2.setState({ subject: text }, function () {
                _this2.props.completeComponentFunction(true);
                _this2.props.dataBetweenComponents(_this2.state);
            });
        };

        _this2.goBack = function () {
            _this2.props.changeFlagStatus();
        };

        _this2.state = {
            stats: _this2.props.data.stats,
            variables: _this2.props.data.variables,
            filename: _this2.props.data.filename,
            subject: '',
            file_data: _this2.props.data.file_data,
            variableForTemplate: _this2.props.data.variables
        };
        _this2.subjectInputRef = _react2.default.createRef();
        return _this2;
    }

    (0, _createClass3.default)(Stats, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            var variables = [];
            var stringVariables = this.state.variables;

            var _loop = function _loop(key) {
                variables.push(_react2.default.createElement(_components.Button, { className: _File2.default.variablesOptions, name: _this3.state.variables[key], color: 'blue',
                    onClick: function onClick() {
                        return _this3.addVariable(stringVariables[key]);
                    } }));
            };

            for (var key in stringVariables) {
                _loop(key);
            }
            this.setState({ variables: variables });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(
                'div',
                { className: _File2.default.statsContainer },
                _react2.default.createElement(
                    'div',
                    { className: _File2.default.fileInfo },
                    _react2.default.createElement(
                        'div',
                        { className: _File2.default.fileInfoHeader },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Informacion del archivo'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.imgContainer },
                            _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/file.svg') }),
                            _react2.default.createElement(
                                'span',
                                null,
                                this.state.filename
                            )
                        ),
                        _react2.default.createElement(_components.Button, { className: _File2.default.buttonContainer, color: 'lightGreen', name: 'Cambiar archivo',
                            onClick: function onClick() {
                                return _this4.goBack();
                            } })
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: { height: '100%' } },
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.variablesContainer },
                            _react2.default.createElement(
                                'span',
                                { style: { marginLeft: '4%' } },
                                ' Variables disponibles en archivo '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.variableFromState },
                                this.state.variables
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _File2.default.fileStats },
                    _react2.default.createElement(
                        'div',
                        { className: _File2.default.statsHeader },
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.statsContainer },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Asunto del correo'
                            ),
                            _react2.default.createElement('input', { ref: this.subjectInputRef, type: 'text', placeholder: 'Aqui puedes escribir el asunto del correo usando las variables del archivo.',
                                onChange: function onChange(event) {
                                    return _this4.getSubject(event.target.value);
                                }, value: this.state.subject
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _File2.default.statsContent },
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.titles },
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'L\xEDneas correctas'
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'L\xEDneas con error'
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'L\xEDneas duplicadas'
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'L\xEDneas con formato inv\xE1lido'
                                ),
                                ' '
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _File2.default.results },
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    this.state.stats.lines_ok
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    this.state.stats.lines_error.total_error
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _File2.default.borderLine },
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    this.state.stats.lines_error.duplicates
                                ),
                                ' '
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    this.state.stats.lines_error.invalid_format
                                ),
                                ' '
                            )
                        )
                    )
                )
            );
        }
    }]);
    return Stats;
}(_react2.default.Component);